export const getUserDisplayName = (decodedIdToken: {
  preferred_username?: string;
  name?: string;
  email?: string;
  sub: string;
}): string => {
  return (
    decodedIdToken.preferred_username ??
    decodedIdToken.name ??
    decodedIdToken.email ??
    decodedIdToken.sub
  );
};
